
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/on-boarding/accredited-investor",
      function () {
        return require("private-next-pages/on-boarding/accredited-investor.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/on-boarding/accredited-investor"])
      });
    }
  